
// ── Current logged-in user (System Admin) ──────────────────────────
export const mockCurrentUser= {
  id: '1',
  firebaseUID: 'uid_admin_001',
  name: 'Mr. Naphtali Osika',
  email: 'n.osika@jooust.ac.ke',
  role: 'system_admin',
  assignedProjects: ['proj_001', 'proj_002', 'proj_003', 'proj_004', 'proj_005', 'proj_006', 'proj_007'],
  institutionalUnit: 'ICT & Systems Administration',
  isActive: true,
  lastLogin: '2026-03-03T07:45:00Z',
}

// ── All users across every role cluster ────────────────────────────
export const mockUsers= [
  mockCurrentUser,
  // Senior Management – VC
  {
    id: '2',
    firebaseUID: 'uid_sm_vc',
    name: 'Prof. Emily Akuno',
    email: 'e.akuno@jooust.ac.ke',
    role: 'senior_management',
    assignedProjects: [],
    institutionalUnit: 'Office of the Vice-Chancellor',
    isActive: true,
    lastLogin: '2026-03-02T09:00:00Z',
  },
  // Senior Management – DVC Research, Innovation & Outreach
  {
    id: '3',
    firebaseUID: 'uid_sm_dvc_rio',
    name: 'Prof. Thuo',
    email: 'thuo@jooust.ac.ke',
    role: 'senior_management',
    assignedProjects: [],
    institutionalUnit: 'Office of DVC - Research, Innovation & Outreach',
    isActive: true,
    lastLogin: '2026-03-02T08:15:00Z',
  },
  // Senior Management – DVC Academic & Student Affairs
  {
    id: '4',
    firebaseUID: 'uid_sm_dvc_asa',
    name: 'Prof. Ateka',
    email: 'ateka@jooust.ac.ke',
    role: 'senior_management',
    assignedProjects: [],
    institutionalUnit: 'Office of DVC - Academic & Student Affairs',
    isActive: true,
    lastLogin: '2026-03-01T10:30:00Z',
  },
  // Programme Manager
  {
    id: '5',
    firebaseUID: 'uid_pm_001',
    name: 'Prof. Silvance Abeka',
    email: 's.abeka@jooust.ac.ke',
    role: 'prog_manager',
    assignedProjects: ['proj_001', 'proj_002', 'proj_003', 'proj_005'],
    institutionalUnit: 'Directorate of Research & Innovation',
    isActive: true,
    lastLogin: '2026-03-03T06:30:00Z',
  },
  // Principal Investigators
  {
    id: '6',
    firebaseUID: 'uid_pi_001',
    name: 'Prof. Dennis Ochuodho',
    email: 'd.ochuodho@jooust.ac.ke',
    role: 'pi',
    assignedProjects: ['proj_001'],
    institutionalUnit: 'Department of Biological Sciences',
    isActive: true,
    lastLogin: '2026-03-02T07:00:00Z',
  },
  {
    id: '7',
    firebaseUID: 'uid_pi_002',
    name: 'Dr. Mary Orinda',
    email: 'm.orinda@jooust.ac.ke',
    role: 'pi',
    assignedProjects: ['proj_002', 'proj_006'],
    institutionalUnit: 'Department of Health Sciences',
    isActive: true,
    lastLogin: '2026-03-02T11:20:00Z',
  },
  {
    id: '8',
    firebaseUID: 'uid_pi_003',
    name: 'Dr. Onjala',
    email: 'onjala@jooust.ac.ke',
    role: 'pi',
    assignedProjects: ['proj_003'],
    institutionalUnit: 'Department of Economics & Development Studies',
    isActive: true,
    lastLogin: '2026-03-01T14:45:00Z',
  },
  {
    id: '9',
    firebaseUID: 'uid_pi_004',
    name: 'Dr. Kenneth Odhiambo',
    email: 'k.odhiambo@jooust.ac.ke',
    role: 'pi',
    assignedProjects: ['proj_004'],
    institutionalUnit: 'Department of Information Technology',
    isActive: true,
    lastLogin: '2026-02-28T09:10:00Z',
  },
  {
    id: '10',
    firebaseUID: 'uid_pi_005',
    name: 'Dr. Florence Achieng',
    email: 'f.achieng@jooust.ac.ke',
    role: 'pi',
    assignedProjects: ['proj_005'],
    institutionalUnit: 'Department of Chemistry',
    isActive: true,
    lastLogin: '2026-03-02T16:00:00Z',
  },
  // Project Officers
  {
    id: '11',
    firebaseUID: 'uid_po_001',
    name: 'Mr. Brian Otieno',
    email: 'b.otieno@jooust.ac.ke',
    role: 'project_officer',
    assignedProjects: ['proj_001', 'proj_002'],
    institutionalUnit: 'Research & Innovation Directorate',
    isActive: true,
    lastLogin: '2026-03-02T13:00:00Z',
  },
  {
    id: '12',
    firebaseUID: 'uid_po_002',
    name: 'Ms. Lucy Moraa',
    email: 'l.moraa@jooust.ac.ke',
    role: 'project_officer',
    assignedProjects: ['proj_003', 'proj_004'],
    institutionalUnit: 'Research & Innovation Directorate',
    isActive: true,
    lastLogin: '2026-03-01T15:30:00Z',
  },
  // MEL Officers
  {
    id: '13',
    firebaseUID: 'uid_mel_001',
    name: 'Mr. Peter Kamau',
    email: 'p.kamau@jooust.ac.ke',
    role: 'mel_officer',
    assignedProjects: ['proj_001', 'proj_002', 'proj_003', 'proj_005'],
    institutionalUnit: 'Monitoring, Evaluation & Learning Unit',
    isActive: true,
    lastLogin: '2026-03-03T08:00:00Z',
  },
  {
    id: '14',
    firebaseUID: 'uid_mel_002',
    name: 'Ms. Esther Nyambura',
    email: 'e.nyambura@jooust.ac.ke',
    role: 'mel_officer',
    assignedProjects: ['proj_004', 'proj_006', 'proj_007'],
    institutionalUnit: 'Monitoring, Evaluation & Learning Unit',
    isActive: true,
    lastLogin: '2026-03-02T10:00:00Z',
  },
  // Finance Liaison
  {
    id: '15',
    firebaseUID: 'uid_fin_001',
    name: 'Ms. Grace Adhiambo',
    email: 'g.adhiambo@jooust.ac.ke',
    role: 'finance_liaison',
    assignedProjects: ['proj_001', 'proj_002', 'proj_003', 'proj_004', 'proj_005'],
    institutionalUnit: 'Finance Department',
    isActive: true,
    lastLogin: '2026-03-02T08:30:00Z',
  },
  {
    id: '16',
    firebaseUID: 'uid_fin_002',
    name: 'Mr. Joseph Wafula',
    email: 'j.wafula@jooust.ac.ke',
    role: 'finance_liaison',
    assignedProjects: ['proj_006', 'proj_007'],
    institutionalUnit: 'Finance Department',
    isActive: true,
    lastLogin: '2026-02-27T12:00:00Z',
  },
  // Partners
  {
    id: '17',
    firebaseUID: 'uid_partner_001',
    name: 'Dr. James Mwangi (USAID)',
    email: 'j.mwangi@usaid.gov',
    role: 'partner',
    assignedProjects: ['proj_001'],
    institutionalUnit: 'USAID Kenya',
    isActive: true,
    lastLogin: '2026-02-20T09:00:00Z',
  },
  {
    id: '18',
    firebaseUID: 'uid_partner_002',
    name: 'Ms. Claire Dupont (EU)',
    email: 'c.dupont@eu-delegation.ke',
    role: 'partner',
    assignedProjects: ['proj_002'],
    institutionalUnit: 'EU Delegation Kenya',
    isActive: true,
    lastLogin: '2026-02-18T11:00:00Z',
  },
  // Procurement
  {
    id: '19',
    firebaseUID: 'uid_proc_001',
    name: 'Mr. Daniel Omondi',
    email: 'd.omondi@jooust.ac.ke',
    role: 'procurement',
    assignedProjects: ['proj_001', 'proj_002', 'proj_003', 'proj_004'],
    institutionalUnit: 'Procurement Department',
    isActive: true,
    lastLogin: '2026-03-01T08:00:00Z',
  },
  // Inactive user
  {
    id: '20',
    firebaseUID: 'uid_pi_006',
    name: 'Dr. Samuel Kibet',
    email: 's.kibet@jooust.ac.ke',
    role: 'pi',
    assignedProjects: [],
    institutionalUnit: 'Department of Mathematics',
    isActive: false,
    lastLogin: '2025-11-15T14:00:00Z',
  },
]

// ── Awards (Grants) ────────────────────────────────────────────────
export const mockAwards= [
  {
    id: 'award_001',
    donorName: 'USAID',
    grantNumber: 'USAID-KE-2024-001',
    title: 'Climate-Smart Agriculture Innovation Programme',
    startDate: '2024-01-15',
    endDate: '2027-01-14',
    totalBudget: 2500000,
    currency: 'USD',
    status: 'active',
    implementingUnits: ['Faculty of Agriculture', 'Faculty of Biological Sciences'],
    partnerIds: ['17'],
  },
  {
    id: 'award_002',
    donorName: 'European Union',
    grantNumber: 'EU-HRZ-2023-045',
    title: 'Lake Victoria Biodiversity & Community Health',
    startDate: '2023-06-01',
    endDate: '2026-05-31',
    totalBudget: 1800000,
    currency: 'EUR',
    status: 'active',
    implementingUnits: ['Faculty of Health Sciences', 'Faculty of Biological Sciences'],
    partnerIds: ['18'],
  },
  {
    id: 'award_003',
    donorName: 'World Bank',
    grantNumber: 'WB-ACE-2025-012',
    title: 'Kenya Economic Resilience & Livelihoods Study',
    startDate: '2025-03-01',
    endDate: '2028-02-28',
    totalBudget: 3200000,
    currency: 'USD',
    status: 'active',
    implementingUnits: ['Faculty of Arts & Social Sciences'],
    partnerIds: [],
  },
  {
    id: 'award_004',
    donorName: 'DFID / UK Aid',
    grantNumber: 'DFID-DIG-2024-019',
    title: 'Digital Skills & ICT Innovation Hub',
    startDate: '2024-06-01',
    endDate: '2027-05-31',
    totalBudget: 1500000,
    currency: 'GBP',
    status: 'active',
    implementingUnits: ['Faculty of Information Science & Technology'],
    partnerIds: [],
  },
  {
    id: 'award_005',
    donorName: 'USAID',
    grantNumber: 'USAID-KE-2025-007',
    title: 'Water Quality & Sanitation Research Programme',
    startDate: '2025-01-01',
    endDate: '2027-12-31',
    totalBudget: 1200000,
    currency: 'USD',
    status: 'active',
    implementingUnits: ['Faculty of Science', 'Faculty of Engineering'],
    partnerIds: ['17'],
  },
  {
    id: 'award_006',
    donorName: 'European Union',
    grantNumber: 'EU-EDU-2022-033',
    title: 'Strengthening Community Health Worker Training',
    startDate: '2022-09-01',
    endDate: '2025-08-31',
    totalBudget: 950000,
    currency: 'EUR',
    status: 'active',
    implementingUnits: ['Faculty of Health Sciences'],
    partnerIds: ['18'],
  },
  {
    id: 'award_007',
    donorName: 'World Bank',
    grantNumber: 'WB-INFRA-2025-004',
    title: 'Renewable Energy Research & Campus Sustainability',
    startDate: '2025-06-01',
    endDate: '2028-05-31',
    totalBudget: 2100000,
    currency: 'USD',
    status: 'pending',
    implementingUnits: ['Faculty of Engineering'],
    partnerIds: [],
  },
]

// ── Projects ───────────────────────────────────────────────────────
export const mockProjects= [
  {
    id: 'proj_001',
    awardId: 'award_001',
    title: 'Climate-Smart Crop Varieties Research',
    code: 'CSA-R001',
    pi: 'Prof. Dennis Ochuodho',
    team: ['Prof. Dennis Ochuodho', 'Mr. Brian Otieno', 'Mr. Peter Kamau', 'Ms. Grace Adhiambo'],
    status: 'active',
    location: 'Bondo, Siaya County',
    thematicArea: 'Agriculture & Food Security',
    objectives: [
      'Develop 3 climate-resilient crop varieties',
      'Train 500 smallholder farmers',
      'Establish 5 demonstration plots in Siaya County',
    ],
    percentComplete: 45,
  },
  {
    id: 'proj_002',
    awardId: 'award_002',
    title: 'Lake Victoria Fish Species Mapping & Conservation',
    code: 'LV-BIO-002',
    pi: 'Dr. Mary Orinda',
    team: ['Dr. Mary Orinda', 'Mr. Brian Otieno', 'Mr. Peter Kamau'],
    status: 'at-risk',
    location: 'Lake Victoria Basin',
    thematicArea: 'Environmental Science & Health',
    objectives: [
      'Complete biodiversity survey of 12 sampling sites',
      'Publish 4 peer-reviewed papers in SCOPUS-indexed journals',
      'Train 20 postgraduate students in aquatic ecology',
    ],
    percentComplete: 32,
  },
  {
    id: 'proj_003',
    awardId: 'award_003',
    title: 'Livelihoods & Economic Resilience in Western Kenya',
    code: 'ECON-LIV-003',
    pi: 'Dr. Onjala',
    team: ['Dr. Onjala', 'Ms. Lucy Moraa', 'Mr. Peter Kamau'],
    status: 'active',
    location: 'Kisumu, Siaya & Bondo Counties',
    thematicArea: 'Economic Development',
    objectives: [
      'Conduct baseline survey of 2,000 households',
      'Develop economic resilience framework for rural livelihoods',
      'Policy brief for County Government of Kisumu',
    ],
    percentComplete: 18,
  },
  {
    id: 'proj_004',
    awardId: 'award_004',
    title: 'ICT Innovation Incubator & Digital Skills Lab',
    code: 'DIG-HUB-004',
    pi: 'Dr. Kenneth Odhiambo',
    team: ['Dr. Kenneth Odhiambo', 'Ms. Lucy Moraa', 'Ms. Esther Nyambura'],
    status: 'active',
    location: 'JOOUST Main Campus, Bondo',
    thematicArea: 'ICT & Digital Innovation',
    objectives: [
      'Establish innovation lab with 50 workstations',
      'Incubate 30 student-led startups over 3 years',
      'Develop 10 market-ready tech prototypes',
    ],
    percentComplete: 28,
  },
  {
    id: 'proj_005',
    awardId: 'award_005',
    title: 'Water Quality Monitoring in Siaya County',
    code: 'WASH-Q005',
    pi: 'Dr. Florence Achieng',
    team: ['Dr. Florence Achieng', 'Mr. Peter Kamau', 'Ms. Grace Adhiambo'],
    status: 'active',
    location: 'Siaya County',
    thematicArea: 'Water, Sanitation & Hygiene',
    objectives: [
      'Install 15 water quality monitoring stations',
      'Train 100 community health volunteers on WASH practices',
      'Reduce waterborne disease incidence by 20% in target areas',
    ],
    percentComplete: 12,
  },
  {
    id: 'proj_006',
    awardId: 'award_006',
    title: 'Community Health Worker Training & mHealth',
    code: 'CHS-T006',
    pi: 'Dr. Mary Orinda',
    team: ['Dr. Mary Orinda', 'Ms. Esther Nyambura', 'Mr. Joseph Wafula'],
    status: 'completed',
    location: 'Kisumu & Siaya Counties',
    thematicArea: 'Health Systems',
    objectives: [
      'Train 200 community health workers in maternal & child health',
      'Deploy mobile health data collection tool in 50 facilities',
      'Reduce under-5 mortality by 15% in target areas',
    ],
    percentComplete: 95,
  },
  {
    id: 'proj_007',
    awardId: 'award_007',
    title: 'Solar Microgrid Feasibility & Campus Pilot',
    code: 'REN-SOL-007',
    pi: 'Dr. Kenneth Odhiambo',
    team: ['Dr. Kenneth Odhiambo', 'Ms. Esther Nyambura', 'Mr. Joseph Wafula'],
    status: 'on-hold',
    location: 'JOOUST Main Campus, Bondo',
    thematicArea: 'Renewable Energy',
    objectives: [
      'Complete feasibility study for 500kW solar microgrid',
      'Design pilot installation for 3 campus buildings',
      'Develop sustainability business model',
    ],
    percentComplete: 5,
  },
]

// ── Risks ──────────────────────────────────────────────────────────
export const mockRisks= [
  {
    id: 'risk_001',
    projectId: 'proj_001',
    description: 'Delayed seed procurement due to supply chain disruptions',
    category: 'Procurement',
    likelihood: 4,
    impact: 4,
    riskScore: 16,
    status: 'open',
    owner: 'Prof. Dennis Ochuodho',
  },
  {
    id: 'risk_002',
    projectId: 'proj_002',
    description: 'Adverse weather conditions affecting lake sampling schedule',
    category: 'Environmental',
    likelihood: 3,
    impact: 3,
    riskScore: 9,
    status: 'open',
    owner: 'Dr. Mary Orinda',
  },
  {
    id: 'risk_003',
    projectId: 'proj_004',
    description: 'Equipment delivery delays from international suppliers',
    category: 'Logistics',
    likelihood: 2,
    impact: 5,
    riskScore: 10,
    status: 'mitigated',
    owner: 'Dr. Kenneth Odhiambo',
  },
  {
    id: 'risk_004',
    projectId: 'proj_001',
    description: 'Farmer engagement below target in remote areas of Siaya',
    category: 'Stakeholder',
    likelihood: 3,
    impact: 4,
    riskScore: 12,
    status: 'open',
    owner: 'Mr. Peter Kamau',
  },
  {
    id: 'risk_005',
    projectId: 'proj_003',
    description: 'Household survey data quality issues in hard-to-reach areas',
    category: 'Data Quality',
    likelihood: 3,
    impact: 3,
    riskScore: 9,
    status: 'open',
    owner: 'Dr. Onjala',
  },
  {
    id: 'risk_006',
    projectId: 'proj_002',
    description: 'Key research staff seconded to other projects causing delays',
    category: 'Human Resources',
    likelihood: 4,
    impact: 3,
    riskScore: 12,
    status: 'open',
    owner: 'Dr. Mary Orinda',
  },
  {
    id: 'risk_007',
    projectId: 'proj_005',
    description: 'Vandalism of water monitoring stations in remote areas',
    category: 'Security',
    likelihood: 2,
    impact: 4,
    riskScore: 8,
    status: 'mitigated',
    owner: 'Dr. Florence Achieng',
  },
  {
    id: 'risk_008',
    projectId: 'proj_004',
    description: 'Low student enrollment in digital skills programme',
    category: 'Stakeholder',
    likelihood: 2,
    impact: 3,
    riskScore: 6,
    status: 'closed',
    owner: 'Dr. Kenneth Odhiambo',
  },
  {
    id: 'risk_009',
    projectId: 'proj_006',
    description: 'Community health worker attrition exceeding 10% target',
    category: 'Human Resources',
    likelihood: 3,
    impact: 4,
    riskScore: 12,
    status: 'closed',
    owner: 'Dr. Mary Orinda',
  },
  {
    id: 'risk_010',
    projectId: 'proj_003',
    description: 'Currency fluctuation affecting World Bank grant disbursement',
    category: 'Financial',
    likelihood: 3,
    impact: 5,
    riskScore: 15,
    status: 'open',
    owner: 'Ms. Grace Adhiambo',
  },
  {
    id: 'risk_011',
    projectId: 'proj_001',
    description: 'Intellectual property disputes over new crop varieties',
    category: 'Legal',
    likelihood: 1,
    impact: 5,
    riskScore: 5,
    status: 'open',
    owner: 'Prof. Silvance Abeka',
  },
  {
    id: 'risk_012',
    projectId: 'proj_005',
    description: 'Delayed ethics approval from NACOSTI for field research',
    category: 'Regulatory',
    likelihood: 3,
    impact: 4,
    riskScore: 12,
    status: 'open',
    owner: 'Dr. Florence Achieng',
  },
  {
    id: 'risk_013',
    projectId: 'proj_007',
    description: 'Solar panel supplier unable to meet specifications',
    category: 'Procurement',
    likelihood: 2,
    impact: 4,
    riskScore: 8,
    status: 'open',
    owner: 'Mr. Daniel Omondi',
  },
]

// ── Indicators ─────────────────────────────────────────────────────
export const mockIndicators= [
  // CSA-R001
  {
    id: 'ind_001',
    logframeId: 'lf_001',
    name: 'Number of climate-resilient crop varieties developed',
    level: 'outcome',
    baseline: 0,
    targets: [{ period: 'Y1', value: 1 }, { period: 'Y2', value: 2 }, { period: 'Y3', value: 3 }],
    actual: 1,
    frequency: 'Annual',
    unit: 'Varieties',
  },
  {
    id: 'ind_002',
    logframeId: 'lf_001',
    name: 'Number of smallholder farmers trained',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 150 }, { period: 'Y2', value: 350 }, { period: 'Y3', value: 500 }],
    actual: 220,
    frequency: 'Quarterly',
    unit: 'Farmers',
  },
  {
    id: 'ind_003',
    logframeId: 'lf_001',
    name: 'Demonstration plots established',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 2 }, { period: 'Y2', value: 4 }, { period: 'Y3', value: 5 }],
    actual: 3,
    frequency: 'Biannual',
    unit: 'Plots',
  },
  // LV-BIO-002
  {
    id: 'ind_004',
    logframeId: 'lf_002',
    name: 'Fish species documented in Lake Victoria',
    level: 'output',
    baseline: 45,
    targets: [{ period: 'Y1', value: 60 }, { period: 'Y2', value: 80 }, { period: 'Y3', value: 100 }],
    actual: 58,
    frequency: 'Biannual',
    unit: 'Species',
  },
  {
    id: 'ind_005',
    logframeId: 'lf_002',
    name: 'Peer-reviewed papers published',
    level: 'outcome',
    baseline: 0,
    targets: [{ period: 'Y1', value: 1 }, { period: 'Y2', value: 3 }, { period: 'Y3', value: 4 }],
    actual: 1,
    frequency: 'Annual',
    unit: 'Papers',
  },
  {
    id: 'ind_006',
    logframeId: 'lf_002',
    name: 'Postgraduate students trained in aquatic ecology',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 6 }, { period: 'Y2', value: 14 }, { period: 'Y3', value: 20 }],
    actual: 8,
    frequency: 'Quarterly',
    unit: 'Students',
  },
  // ECON-LIV-003
  {
    id: 'ind_007',
    logframeId: 'lf_003',
    name: 'Households surveyed for baseline',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 800 }, { period: 'Y2', value: 1500 }, { period: 'Y3', value: 2000 }],
    actual: 350,
    frequency: 'Quarterly',
    unit: 'Households',
  },
  // DIG-HUB-004
  {
    id: 'ind_008',
    logframeId: 'lf_004',
    name: 'Student startups incubated',
    level: 'outcome',
    baseline: 0,
    targets: [{ period: 'Y1', value: 10 }, { period: 'Y2', value: 20 }, { period: 'Y3', value: 30 }],
    actual: 4,
    frequency: 'Quarterly',
    unit: 'Startups',
  },
  {
    id: 'ind_009',
    logframeId: 'lf_004',
    name: 'Market-ready tech prototypes developed',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 3 }, { period: 'Y2', value: 7 }, { period: 'Y3', value: 10 }],
    actual: 1,
    frequency: 'Biannual',
    unit: 'Prototypes',
  },
  // WASH-Q005
  {
    id: 'ind_010',
    logframeId: 'lf_005',
    name: 'Water quality monitoring stations installed',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 5 }, { period: 'Y2', value: 10 }, { period: 'Y3', value: 15 }],
    actual: 2,
    frequency: 'Quarterly',
    unit: 'Stations',
  },
  {
    id: 'ind_011',
    logframeId: 'lf_005',
    name: 'Community health volunteers trained on WASH',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 30 }, { period: 'Y2', value: 70 }, { period: 'Y3', value: 100 }],
    actual: 15,
    frequency: 'Quarterly',
    unit: 'Volunteers',
  },
  // CHS-T006 (completed)
  {
    id: 'ind_012',
    logframeId: 'lf_006',
    name: 'Community health workers trained',
    level: 'output',
    baseline: 0,
    targets: [{ period: 'Y1', value: 80 }, { period: 'Y2', value: 150 }, { period: 'Y3', value: 200 }],
    actual: 192,
    frequency: 'Quarterly',
    unit: 'CHWs',
  },
  {
    id: 'ind_013',
    logframeId: 'lf_006',
    name: 'Health facilities deploying mHealth tool',
    level: 'outcome',
    baseline: 0,
    targets: [{ period: 'Y1', value: 15 }, { period: 'Y2', value: 35 }, { period: 'Y3', value: 50 }],
    actual: 47,
    frequency: 'Biannual',
    unit: 'Facilities',
  },
  // Goal-level indicator
  {
    id: 'ind_014',
    logframeId: 'lf_006',
    name: 'Reduction in under-5 mortality in target areas',
    level: 'goal',
    baseline: 100,
    targets: [{ period: 'Y1', value: 95 }, { period: 'Y2', value: 90 }, { period: 'Y3', value: 85 }],
    actual: 88,
    frequency: 'Annual',
    unit: 'Per 1000 live births',
  },
]

// ── Reports ────────────────────────────────────────────────────────
export const mockReports= [
  // CSA-R001 reports
  {
    id: 'rpt_001',
    projectId: 'proj_001',
    reportType: 'progress',
    reportingPeriod: 'Q3 2025',
    dueDate: '2025-10-15',
    submittedAt: '2025-10-12',
    status: 'approved',
  },
  {
    id: 'rpt_002',
    projectId: 'proj_001',
    reportType: 'progress',
    reportingPeriod: 'Q4 2025',
    dueDate: '2026-01-15',
    submittedAt: '2026-01-12',
    status: 'approved',
  },
  {
    id: 'rpt_003',
    projectId: 'proj_001',
    reportType: 'results',
    reportingPeriod: 'Annual 2025',
    dueDate: '2026-02-28',
    submittedAt: '2026-02-25',
    status: 'approved',
  },
  {
    id: 'rpt_004',
    projectId: 'proj_001',
    reportType: 'progress',
    reportingPeriod: 'Q1 2026',
    dueDate: '2026-04-15',
    status: 'draft',
  },
  // LV-BIO-002 reports
  {
    id: 'rpt_005',
    projectId: 'proj_002',
    reportType: 'progress',
    reportingPeriod: 'H1 2025',
    dueDate: '2025-07-31',
    submittedAt: '2025-08-05',
    status: 'approved',
  },
  {
    id: 'rpt_006',
    projectId: 'proj_002',
    reportType: 'progress',
    reportingPeriod: 'H2 2025',
    dueDate: '2026-02-28',
    status: 'overdue',
  },
  {
    id: 'rpt_007',
    projectId: 'proj_002',
    reportType: 'stakeholder',
    reportingPeriod: 'Annual 2025',
    dueDate: '2026-03-15',
    submittedAt: '2026-03-01',
    status: 'submitted',
  },
  // ECON-LIV-003 reports
  {
    id: 'rpt_008',
    projectId: 'proj_003',
    reportType: 'progress',
    reportingPeriod: 'Q1 2026',
    dueDate: '2026-03-31',
    status: 'draft',
  },
  {
    id: 'rpt_009',
    projectId: 'proj_003',
    reportType: 'deliverables',
    reportingPeriod: 'Year 1 Baseline',
    dueDate: '2026-02-15',
    status: 'overdue',
  },
  // DIG-HUB-004 reports
  {
    id: 'rpt_010',
    projectId: 'proj_004',
    reportType: 'progress',
    reportingPeriod: 'Q4 2025',
    dueDate: '2026-01-15',
    submittedAt: '2026-01-14',
    status: 'approved',
  },
  {
    id: 'rpt_011',
    projectId: 'proj_004',
    reportType: 'progress',
    reportingPeriod: 'Q1 2026',
    dueDate: '2026-04-15',
    status: 'draft',
  },
  // WASH-Q005 reports
  {
    id: 'rpt_012',
    projectId: 'proj_005',
    reportType: 'progress',
    reportingPeriod: 'Q4 2025',
    dueDate: '2026-01-31',
    submittedAt: '2026-01-30',
    status: 'approved',
  },
  {
    id: 'rpt_013',
    projectId: 'proj_005',
    reportType: 'progress',
    reportingPeriod: 'Q1 2026',
    dueDate: '2026-04-30',
    status: 'draft',
  },
  // CHS-T006 reports (completed project)
  {
    id: 'rpt_014',
    projectId: 'proj_006',
    reportType: 'closeout',
    reportingPeriod: 'Final',
    dueDate: '2025-11-30',
    submittedAt: '2025-11-28',
    status: 'approved',
  },
  {
    id: 'rpt_015',
    projectId: 'proj_006',
    reportType: 'impact',
    reportingPeriod: 'Final Impact Assessment',
    dueDate: '2025-12-31',
    submittedAt: '2025-12-20',
    status: 'approved',
  },
  {
    id: 'rpt_016',
    projectId: 'proj_006',
    reportType: 'results',
    reportingPeriod: 'Annual 2025',
    dueDate: '2026-01-31',
    submittedAt: '2026-01-15',
    status: 'approved',
  },
  // Cross-cutting
  {
    id: 'rpt_017',
    projectId: 'proj_001',
    reportType: 'stakeholder',
    reportingPeriod: 'Annual 2025',
    dueDate: '2026-03-31',
    submittedAt: '2026-03-02',
    status: 'submitted',
  },
  {
    id: 'rpt_018',
    projectId: 'proj_005',
    reportType: 'deliverables',
    reportingPeriod: 'Inception Report',
    dueDate: '2025-06-30',
    submittedAt: '2025-06-28',
    status: 'approved',
  },
]

// ── Notifications ──────────────────────────────────────────────────
export const mockNotifications= [
  {
    id: 'notif_001',
    userId: '1',
    type: 'report_due',
    message: 'Q1 2026 Progress Report for CSA-R001 due in 43 days - PI: Prof. Dennis Ochuodho',
    link: '/dashboard/reports',
    isRead: false,
    priority: 'medium',
    createdAt: '2026-03-03T07:00:00Z',
  },
  {
    id: 'notif_002',
    userId: '1',
    type: 'mel_review',
    message: 'MEL data submission awaiting review for LV-BIO-002 - Submitted by Mr. Peter Kamau',
    link: '/dashboard/mel',
    isRead: false,
    priority: 'high',
    createdAt: '2026-03-02T16:30:00Z',
  },
  {
    id: 'notif_003',
    userId: '1',
    type: 'risk_escalation',
    message: 'HIGH RISK escalated: Currency fluctuation affecting WB grant (ECON-LIV-003) - Owner: Ms. Grace Adhiambo',
    link: '/dashboard/risks',
    isRead: false,
    priority: 'high',
    createdAt: '2026-03-02T10:00:00Z',
  },
  {
    id: 'notif_004',
    userId: '1',
    type: 'task_overdue',
    message: 'OVERDUE: H2 2025 Progress Report for LV-BIO-002 - PI: Dr. Mary Orinda',
    link: '/dashboard/reports',
    isRead: false,
    priority: 'high',
    createdAt: '2026-03-01T09:00:00Z',
  },
  {
    id: 'notif_005',
    userId: '1',
    type: 'approval',
    message: 'Annual stakeholder engagement report APPROVED for CSA-R001 by Prof. Silvance Abeka',
    link: '/dashboard/reports',
    isRead: true,
    priority: 'low',
    createdAt: '2026-03-02T14:00:00Z',
  },
  {
    id: 'notif_006',
    userId: '1',
    type: 'report_due',
    message: 'Year 1 Baseline Deliverable for ECON-LIV-003 is OVERDUE - PI: Dr. Onjala',
    link: '/dashboard/reports',
    isRead: false,
    priority: 'high',
    createdAt: '2026-02-28T08:00:00Z',
  },
  {
    id: 'notif_007',
    userId: '1',
    type: 'erp_sync',
    message: 'Finance sync completed: Q4 2025 expenditure data imported for 5 active projects',
    link: '/dashboard/finance',
    isRead: true,
    priority: 'low',
    createdAt: '2026-02-25T12:00:00Z',
  },
  {
    id: 'notif_008',
    userId: '1',
    type: 'approval',
    message: 'Prof. Emily Akuno (VC) approved closeout report for CHS-T006',
    link: '/dashboard/reports',
    isRead: true,
    priority: 'medium',
    createdAt: '2026-02-20T11:00:00Z',
  },
]

// ── Dashboard Statistics ───────────────────────────────────────────
export const portfolioStats = {
  totalAwards: mockAwards.filter((a) => a.status !== 'pending').length,
  totalProjects: mockProjects.length,
  activeProjects: mockProjects.filter((p) => p.status === 'active').length,
  atRiskProjects: mockProjects.filter((p) => p.status === 'at-risk').length,
  completedProjects: mockProjects.filter((p) => p.status === 'completed').length,
  onHoldProjects: mockProjects.filter((p) => p.status === 'on-hold').length,
  totalBudget: mockAwards.reduce((sum, a) => sum + a.totalBudget, 0),
  totalSpent: 4850000,
  openRisks: mockRisks.filter((r) => r.status === 'open').length,
  mitigatedRisks: mockRisks.filter((r) => r.status === 'mitigated').length,
  closedRisks: mockRisks.filter((r) => r.status === 'closed').length,
  reportsDue: mockReports.filter(
    (r) => r.status === 'draft' || r.status === 'overdue',
  ).length,
  reportsOverdue: mockReports.filter((r) => r.status === 'overdue').length,
  reportsApproved: mockReports.filter((r) => r.status === 'approved').length,
  reportsSubmitted: mockReports.filter((r) => r.status === 'submitted').length,
  indicatorsOnTrack: 6,
  indicatorsOffTrack: 3,
  indicatorsAtRisk: 5,
}

export const budgetByProject = [
  { name: 'CSA-R001', budgeted: 800000, actual: 360000, committed: 120000 },
  { name: 'LV-BIO-002', budgeted: 600000, actual: 250000, committed: 80000 },
  { name: 'ECON-LIV-003', budgeted: 1000000, actual: 180000, committed: 200000 },
  { name: 'DIG-HUB-004', budgeted: 500000, actual: 140000, committed: 95000 },
  { name: 'WASH-Q005', budgeted: 400000, actual: 48000, committed: 60000 },
  { name: 'CHS-T006', budgeted: 950000, actual: 902500, committed: 12000 },
  { name: 'REN-SOL-007', budgeted: 700000, actual: 35000, committed: 0 },
]

export const projectTimeline = [
  { month: 'Oct', planned: 30, actual: 28 },
  { month: 'Nov', planned: 34, actual: 31 },
  { month: 'Dec', planned: 38, actual: 34 },
  { month: 'Jan', planned: 42, actual: 37 },
  { month: 'Feb', planned: 47, actual: 40 },
  { month: 'Mar', planned: 52, actual: 43 },
]

// ── Issues ────────────────────────────────────────────────────────
export const mockIssues= [
  { id: 'iss_001', projectId: 'proj_001', title: 'Delayed seed delivery from Kenya Seed Company', description: 'Seed order placed in January has not arrived; threatens Q2 planting schedule.', severity: 'high', status: 'open', assignee: 'Mr. Daniel Omondi', raisedBy: 'Prof. Dennis Ochuodho', raisedDate: '2026-02-15', category: 'Procurement' },
  { id: 'iss_002', projectId: 'proj_002', title: 'Boat engine failure at Dunga Beach sampling point', description: 'Research boat engine broke down and requires replacement part from Nairobi.', severity: 'critical', status: 'in-progress', assignee: 'Mr. Brian Otieno', raisedBy: 'Dr. Mary Orinda', raisedDate: '2026-02-22', category: 'Equipment' },
  { id: 'iss_003', projectId: 'proj_003', title: 'County government data-sharing MOU pending approval', description: 'Kisumu County has not signed the MOU for household survey data access.', severity: 'medium', status: 'open', assignee: 'Dr. Onjala', raisedBy: 'Ms. Lucy Moraa', raisedDate: '2026-01-10', category: 'Regulatory' },
  { id: 'iss_004', projectId: 'proj_004', title: 'Internet connectivity issues in Innovation Lab', description: 'Frequent network outages affecting student incubation sessions.', severity: 'high', status: 'in-progress', assignee: 'Mr. Naphtali Osika', raisedBy: 'Dr. Kenneth Odhiambo', raisedDate: '2026-02-05', category: 'Infrastructure' },
  { id: 'iss_005', projectId: 'proj_005', title: 'Vandalized monitoring station at Usenge', description: 'Station #3 solar panel stolen; data collection interrupted for 2 weeks.', severity: 'high', status: 'resolved', assignee: 'Dr. Florence Achieng', raisedBy: 'Mr. Peter Kamau', raisedDate: '2026-01-20', resolvedDate: '2026-02-10', category: 'Security' },
  { id: 'iss_006', projectId: 'proj_002', title: 'Lab reagent procurement delayed by KEBS certification', description: 'Water quality testing reagents held at customs for KEBS check.', severity: 'medium', status: 'open', assignee: 'Mr. Daniel Omondi', raisedBy: 'Dr. Mary Orinda', raisedDate: '2026-02-28', category: 'Procurement' },
  { id: 'iss_007', projectId: 'proj_001', title: 'Community resistance in Usigu sub-county', description: 'Farmers in Usigu reluctant to adopt new crop varieties; community sensitization needed.', severity: 'medium', status: 'in-progress', assignee: 'Mr. Peter Kamau', raisedBy: 'Prof. Dennis Ochuodho', raisedDate: '2026-02-01', category: 'Stakeholder' },
  { id: 'iss_008', projectId: 'proj_006', title: 'CHW data quality audit findings', description: 'Audit found 15% of mHealth records incomplete; remediation completed.', severity: 'low', status: 'closed', assignee: 'Ms. Esther Nyambura', raisedBy: 'Mr. Peter Kamau', raisedDate: '2025-09-10', resolvedDate: '2025-10-05', category: 'Data Quality' },
  { id: 'iss_009', projectId: 'proj_003', title: 'Enumerator training materials not yet finalized', description: 'Household survey training manual needs review before field deployment.', severity: 'low', status: 'resolved', assignee: 'Ms. Lucy Moraa', raisedBy: 'Dr. Onjala', raisedDate: '2026-01-25', resolvedDate: '2026-02-15', category: 'Capacity' },
  { id: 'iss_010', projectId: 'proj_004', title: 'Mismatch in budget line allocation for software licenses', description: 'Finance flagged discrepancy between approved budget and PO for Adobe licenses.', severity: 'medium', status: 'open', assignee: 'Ms. Grace Adhiambo', raisedBy: 'Dr. Kenneth Odhiambo', raisedDate: '2026-03-01', category: 'Finance' },
]

// ── Stakeholders ──────────────────────────────────────────────────
export const mockStakeholders= [
  { id: 'sh_001', name: 'Prof. Emily Akuno', organization: 'JOOUST', type: 'internal', role: 'Vice Chancellor & Patron', email: 'e.akuno@jooust.ac.ke', phone: '+254 700 100 001', influence: 'high', interest: 'high', projectIds: [] },
  { id: 'sh_002', name: 'Prof. Thuo', organization: 'JOOUST', type: 'internal', role: 'DVC Research, Innovation & Outreach', email: 'thuo@jooust.ac.ke', phone: '+254 700 100 002', influence: 'high', interest: 'high', projectIds: [] },
  { id: 'sh_003', name: 'Dr. James Mwangi', organization: 'USAID Kenya', type: 'donor', role: 'Programme Officer - Agriculture', email: 'j.mwangi@usaid.gov', phone: '+254 20 862 2000', influence: 'high', interest: 'high', projectIds: ['proj_001', 'proj_005'] },
  { id: 'sh_004', name: 'Ms. Claire Dupont', organization: 'EU Delegation Kenya', type: 'donor', role: 'Project Coordinator - Health & Environment', email: 'c.dupont@eu-delegation.ke', phone: '+254 20 271 2860', influence: 'high', interest: 'high', projectIds: ['proj_002', 'proj_006'] },
  { id: 'sh_005', name: 'Hon. James Orengo', organization: 'Siaya County Government', type: 'government', role: 'Governor, Siaya County', email: 'governor@siaya.go.ke', phone: '+254 57 202 0001', influence: 'high', interest: 'medium', projectIds: ['proj_001', 'proj_005'] },
  { id: 'sh_006', name: 'Dr. Susan Auma', organization: 'KEMRI', type: 'external', role: 'Collaborative Researcher - Tropical Diseases', email: 's.auma@kemri.go.ke', phone: '+254 20 272 2541', influence: 'medium', interest: 'high', projectIds: ['proj_002', 'proj_006'] },
  { id: 'sh_007', name: 'Mr. Patrick Onyango', organization: 'Bondo Sub-County', type: 'community', role: 'Community Development Officer', email: 'p.onyango@bondo.go.ke', phone: '+254 711 234 567', influence: 'medium', interest: 'high', projectIds: ['proj_001'] },
  { id: 'sh_008', name: 'Ms. Martha Achieng', organization: 'NACOSTI', type: 'government', role: 'Research Licensing Officer', email: 'm.achieng@nacosti.go.ke', phone: '+254 20 231 0571', influence: 'medium', interest: 'medium', projectIds: ['proj_005'] },
  { id: 'sh_009', name: 'Mr. John Otieno', organization: 'World Bank Kenya', type: 'donor', role: 'Task Team Leader - Kenya Economic Programme', email: 'j.otieno@worldbank.org', phone: '+254 20 322 6000', influence: 'high', interest: 'medium', projectIds: ['proj_003', 'proj_007'] },
  { id: 'sh_010', name: 'Prof. Silvance Abeka', organization: 'JOOUST', type: 'internal', role: 'Director of Research & Innovation', email: 's.abeka@jooust.ac.ke', phone: '+254 700 100 005', influence: 'high', interest: 'high', projectIds: ['proj_001', 'proj_002', 'proj_003', 'proj_005'] },
  { id: 'sh_011', name: 'Ms. Sarah Wanjiku', organization: 'DFID Kenya', type: 'donor', role: 'Senior Adviser - Digital Development', email: 's.wanjiku@fcdo.gov.uk', phone: '+254 20 284 4000', influence: 'high', interest: 'medium', projectIds: ['proj_004'] },
  { id: 'sh_012', name: 'Chief Moses Oloo', organization: 'Usenge Community', type: 'community', role: 'Area Chief - Usenge Location', email: '', phone: '+254 722 456 789', influence: 'low', interest: 'high', projectIds: ['proj_001', 'proj_005'] },
]

// ── Evidence ──────────────────────────────────────────────────────
export const mockEvidence= [
  { id: 'ev_001', indicatorId: 'ind_001', projectId: 'proj_001', title: 'Crop Variety Trial Report - Y1', type: 'report', uploadedBy: 'Prof. Dennis Ochuodho', uploadedAt: '2025-12-15T10:00:00Z', verified: true, verifiedBy: 'Mr. Peter Kamau', fileSize: '2.4 MB', description: 'Year 1 agronomic trial results for 3 drought-tolerant sorghum lines.' },
  { id: 'ev_002', indicatorId: 'ind_002', projectId: 'proj_001', title: 'Farmer Training Attendance Sheets Q1-Q3', type: 'document', uploadedBy: 'Mr. Brian Otieno', uploadedAt: '2025-10-20T14:00:00Z', verified: true, verifiedBy: 'Mr. Peter Kamau', fileSize: '1.1 MB', description: 'Signed attendance registers for 220 smallholder farmers trained across 8 sessions.' },
  { id: 'ev_003', indicatorId: 'ind_003', projectId: 'proj_001', title: 'Demonstration Plot GPS Photos', type: 'photo', uploadedBy: 'Mr. Brian Otieno', uploadedAt: '2025-11-05T09:30:00Z', verified: true, verifiedBy: 'Mr. Peter Kamau', fileSize: '8.7 MB', description: 'Geotagged photographs of 3 established demo plots in Bondo and Rarieda.' },
  { id: 'ev_004', indicatorId: 'ind_004', projectId: 'proj_002', title: 'Lake Victoria Fish Biodiversity Dataset', type: 'dataset', uploadedBy: 'Dr. Mary Orinda', uploadedAt: '2025-08-15T11:00:00Z', verified: false, fileSize: '15.2 MB', description: 'Species identification data from 8 out of 12 planned sampling sites.' },
  { id: 'ev_005', indicatorId: 'ind_005', projectId: 'proj_002', title: 'Published Paper - Cichlid Population Dynamics', type: 'document', uploadedBy: 'Dr. Mary Orinda', uploadedAt: '2026-01-10T08:00:00Z', verified: true, verifiedBy: 'Ms. Esther Nyambura', fileSize: '0.9 MB', description: 'Peer-reviewed paper accepted in Journal of East African Fisheries.' },
  { id: 'ev_006', indicatorId: 'ind_007', projectId: 'proj_003', title: 'Household Baseline Survey Raw Data', type: 'dataset', uploadedBy: 'Ms. Lucy Moraa', uploadedAt: '2026-02-20T15:00:00Z', verified: false, fileSize: '22.1 MB', description: 'ODK-collected baseline data for 350 households across 3 counties.' },
  { id: 'ev_007', indicatorId: 'ind_008', projectId: 'proj_004', title: 'Startup Incubation Progress Report', type: 'report', uploadedBy: 'Dr. Kenneth Odhiambo', uploadedAt: '2026-01-30T10:00:00Z', verified: true, verifiedBy: 'Ms. Esther Nyambura', fileSize: '3.5 MB', description: 'Report documenting 4 student startups mentored in Q3-Q4 2025.' },
  { id: 'ev_008', indicatorId: 'ind_010', projectId: 'proj_005', title: 'Water Station Installation Photos', type: 'photo', uploadedBy: 'Dr. Florence Achieng', uploadedAt: '2025-12-01T13:00:00Z', verified: true, verifiedBy: 'Mr. Peter Kamau', fileSize: '12.3 MB', description: 'Geotagged photos of 2 installed water quality monitoring stations.' },
  { id: 'ev_009', indicatorId: 'ind_012', projectId: 'proj_006', title: 'CHW Training Completion Certificates', type: 'document', uploadedBy: 'Ms. Esther Nyambura', uploadedAt: '2025-08-01T09:00:00Z', verified: true, verifiedBy: 'Mr. Peter Kamau', fileSize: '4.8 MB', description: 'Scanned certificates for 192 community health workers who completed training.' },
  { id: 'ev_010', indicatorId: 'ind_013', projectId: 'proj_006', title: 'mHealth Deployment Dashboard Screenshot', type: 'photo', uploadedBy: 'Dr. Mary Orinda', uploadedAt: '2025-11-20T16:00:00Z', verified: true, verifiedBy: 'Ms. Esther Nyambura', fileSize: '0.5 MB', description: 'Screenshot showing 47 facilities actively using the mHealth data tool.' },
  { id: 'ev_011', indicatorId: 'ind_011', projectId: 'proj_005', title: 'WASH Volunteer Training Survey Results', type: 'survey', uploadedBy: 'Mr. Peter Kamau', uploadedAt: '2026-01-15T11:30:00Z', verified: false, fileSize: '1.8 MB', description: 'Post-training evaluation survey for 15 community WASH volunteers.' },
]

// ── Finance Records ───────────────────────────────────────────────
export const mockFinanceRecords= [
  // CSA-R001
  { id: 'fin_001', projectId: 'proj_001', category: 'Personnel', budgeted: 320000, actual: 145000, committed: 48000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_002', projectId: 'proj_001', category: 'Equipment', budgeted: 150000, actual: 82000, committed: 35000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_003', projectId: 'proj_001', category: 'Travel & Fieldwork', budgeted: 120000, actual: 65000, committed: 20000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_004', projectId: 'proj_001', category: 'Supplies & Materials', budgeted: 80000, actual: 38000, committed: 12000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_005', projectId: 'proj_001', category: 'Indirect Costs', budgeted: 130000, actual: 30000, committed: 5000, period: 'FY 2025/26', currency: 'USD' },
  // LV-BIO-002
  { id: 'fin_006', projectId: 'proj_002', category: 'Personnel', budgeted: 240000, actual: 110000, committed: 35000, period: 'FY 2025/26', currency: 'EUR' },
  { id: 'fin_007', projectId: 'proj_002', category: 'Equipment', budgeted: 120000, actual: 55000, committed: 25000, period: 'FY 2025/26', currency: 'EUR' },
  { id: 'fin_008', projectId: 'proj_002', category: 'Travel & Fieldwork', budgeted: 100000, actual: 48000, committed: 12000, period: 'FY 2025/26', currency: 'EUR' },
  { id: 'fin_009', projectId: 'proj_002', category: 'Subcontracts', budgeted: 80000, actual: 25000, committed: 8000, period: 'FY 2025/26', currency: 'EUR' },
  { id: 'fin_010', projectId: 'proj_002', category: 'Indirect Costs', budgeted: 60000, actual: 12000, committed: 0, period: 'FY 2025/26', currency: 'EUR' },
  // ECON-LIV-003
  { id: 'fin_011', projectId: 'proj_003', category: 'Personnel', budgeted: 400000, actual: 80000, committed: 95000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_012', projectId: 'proj_003', category: 'Travel & Fieldwork', budgeted: 250000, actual: 55000, committed: 60000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_013', projectId: 'proj_003', category: 'Equipment', budgeted: 100000, actual: 15000, committed: 25000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_014', projectId: 'proj_003', category: 'Indirect Costs', budgeted: 250000, actual: 30000, committed: 20000, period: 'FY 2025/26', currency: 'USD' },
  // DIG-HUB-004
  { id: 'fin_015', projectId: 'proj_004', category: 'Personnel', budgeted: 200000, actual: 60000, committed: 40000, period: 'FY 2025/26', currency: 'GBP' },
  { id: 'fin_016', projectId: 'proj_004', category: 'Equipment', budgeted: 180000, actual: 52000, committed: 35000, period: 'FY 2025/26', currency: 'GBP' },
  { id: 'fin_017', projectId: 'proj_004', category: 'Supplies & Materials', budgeted: 60000, actual: 18000, committed: 12000, period: 'FY 2025/26', currency: 'GBP' },
  { id: 'fin_018', projectId: 'proj_004', category: 'Indirect Costs', budgeted: 60000, actual: 10000, committed: 8000, period: 'FY 2025/26', currency: 'GBP' },
  // WASH-Q005
  { id: 'fin_019', projectId: 'proj_005', category: 'Personnel', budgeted: 150000, actual: 20000, committed: 25000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_020', projectId: 'proj_005', category: 'Equipment', budgeted: 130000, actual: 15000, committed: 22000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_021', projectId: 'proj_005', category: 'Travel & Fieldwork', budgeted: 80000, actual: 8000, committed: 10000, period: 'FY 2025/26', currency: 'USD' },
  { id: 'fin_022', projectId: 'proj_005', category: 'Indirect Costs', budgeted: 40000, actual: 5000, committed: 3000, period: 'FY 2025/26', currency: 'USD' },
]

// ── Monthly Cash Flow ─────────────────────────────────────────────
export const monthlyCashFlow = [
  { month: 'Jul', inflow: 520000, outflow: 180000 },
  { month: 'Aug', inflow: 310000, outflow: 220000 },
  { month: 'Sep', inflow: 185000, outflow: 265000 },
  { month: 'Oct', inflow: 420000, outflow: 310000 },
  { month: 'Nov', inflow: 280000, outflow: 340000 },
  { month: 'Dec', inflow: 150000, outflow: 290000 },
  { month: 'Jan', inflow: 680000, outflow: 350000 },
  { month: 'Feb', inflow: 320000, outflow: 380000 },
  { month: 'Mar', inflow: 410000, outflow: 295000 },
]
